import Provider from "../../new/provider";

interface IJoinProviderRoutes {
  accept: string;
  reject: string;
}

import Join from "../../../models/appRequests/organizations/join";
import {Hash} from "../../../interfaces/hashInterfaces";
import {IProviderRoutes} from "../../../interfaces/provider";
import {Constructor} from "../../../../global/constructor";
import {IServerData} from "../../../interfaces/serverInterfaces";
import {HTTPMethod} from "../../new/httpMethod";

export default class JoinProvider<T extends Join = Join> extends Provider<T> {
  routes: IProviderRoutes & IJoinProviderRoutes;

  constructor(protected modelType: Constructor<T>, public modelRoot: string, public collectionRoot: string, protected endPointBase: string = collectionRoot) {
    super(modelType, modelRoot, collectionRoot, endPointBase);
    let newRoutes: IJoinProviderRoutes = {
      accept: `${this.endPointBase}/:id/accept`,
      reject: `${this.endPointBase}/:id/reject`,
    };
    Object.assign(this.routes, newRoutes);
  }

  accept(obj: T, objJson?: object): Promise<IServerData<any>> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.replace(this.routes.accept, obj),
        method: HTTPMethod.PATCH,
        json: {[this.modelRoot]: objJson || obj.asJson()}
      }).then(resolve).catch(reject);
    });
  }

  reject(obj: T, objJson?: object): Promise<IServerData> {
    return new Promise<IServerData>((resolve, reject) => {
      this.serverAction({
        endpoint: this.replace(this.routes.reject, obj),
        method: HTTPMethod.PATCH,
      }).then(resolve).catch(reject);
    });
  }
  replacer(route: string, obj: T, metadata: Hash = {}): string {
    return route.replace(':organization_id', obj.organization_id || metadata.organization_id || obj.organization_subdomain || metadata.organization_subdomain);
  };
}
